import { gettext, ngettext } from '@eventbrite/i18n';
import { RefundPolicyProps } from '../../types';
import { Duration } from '../../types/highlights';

// ngettext uses gettext and needs for it to be imported
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ignore = gettext;

export const formatDuration = (duration?: Duration): string | undefined => {
    if (!duration) {
        return undefined;
    }

    const daysText = String(
        ngettext('%(days)s day', '%(days)s days', duration.days, {
            days: duration.days,
        }),
    );
    const hoursText = String(
        ngettext('%(hours)s hour', '%(hours)s hours', duration.hours, {
            hours: duration.hours,
        }),
    );
    const minutesText = String(
        ngettext(
            '%(minutes)s minute',
            '%(minutes)s minutes',
            duration.minutes,
            {
                minutes: duration.minutes,
            },
        ),
    );

    let durationText: string;

    if (duration.days) {
        if (duration.hours) {
            durationText = `${daysText} ${hoursText}`;
        } else {
            durationText = daysText;
        }
    } else if (duration.hours) {
        if (duration.minutes) {
            durationText = `${hoursText} ${minutesText}`;
        } else {
            durationText = hoursText;
        }
    } else {
        durationText = minutesText;
    }

    return durationText;
};

const getValidDaysText = (validDays: number) => {
    return ngettext(
        'Refunds up to %(days)s day before event',
        'Refunds up to %(days)s days before event',
        validDays,
        {
            days: validDays,
        },
    ).toString();
};

export const getTranslatedRefundPolicy = (
    refundPolicy: RefundPolicyProps,
    isRepeating = false,
): string | null => {
    const { isPaidEvent, validDays, isRefundRequestAllowed } = refundPolicy;

    if (!isPaidEvent) {
        return null;
    }

    if (isRepeating && validDays) {
        return getValidDaysText(validDays);
    }

    if (!isRefundRequestAllowed) {
        return gettext('No refunds').toString();
    }

    if (!validDays) {
        return refundPolicy.refundPolicyDescription || null;
    }

    return getValidDaysText(validDays);
};
